import { render, staticRenderFns } from "./TermsProvider.vue?vue&type=template&id=3426ece2"
import script from "./TermsProvider.vue?vue&type=script&lang=js"
export * from "./TermsProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports